// extracted by mini-css-extract-plugin
module.exports = {"contactTextWrapper":"ZRIIxO","desktop":"y2oQW7","mobile":"IC3SqF"};